import {
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  makeStyles,
  useTheme,
} from '@material-ui/core';
import { CheckCircle, Error, RadioButtonUnchecked } from '@material-ui/icons';
import { AutomationAction } from './AutomationActionUtils';

interface AutomationActionsProps {
  actionList: AutomationAction[];
}

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
  },
  success: {
    color: theme.palette.success.main,
  },
}));

export const AutomationActions: React.FC<AutomationActionsProps> = ({ actionList }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <div className={classes.container}>
      {actionList.length > 0 && (
        <>
          <Typography>Automation Actions</Typography>
          <List>
            {actionList.map((item, idx) => {
              return (
                <ListItem key={idx}>
                  <ListItemIcon>
                    {item.status === 'TODO' && <RadioButtonUnchecked />}
                    {item.status === 'IN_PROGRESS' && <CircularProgress size={20} />}
                    {item.status === 'SUCCESS' && <CheckCircle className={classes.success} />}
                    {item.status === 'FAILURE' && <Error color="error" />}
                  </ListItemIcon>
                  <ListItemText primary={item.message} secondary={item.subtitle} />
                </ListItem>
              );
            })}
          </List>
        </>
      )}
    </div>
  );
};
